// React imports.
import React from "react";

import { Assessment2aStepsEnum } from "../state";
import { Assessment2aModel } from "../state";
import { Assessment2aStatusEnum } from "../state";

const Assessment2aBottomParagraph = ({model, state }) => (
    <div>
        {((model.totalVendorStatus === Assessment2aStatusEnum.MeetsMinRequirement5Plus
            ||model.totalVendorStatus === Assessment2aStatusEnum.MeetsMinRequirementUnder5)
            &&model.viewAnywayFlag != true)
          &&  <p>
                No further action is required for Assessment #2A. If you want to
                analyze potential data reliability issues anyway,
                click  &nbsp;
                <button className="dataButton"
                    onClick={(changeEvent) => state.assessment2aViewAnyway(changeEvent, model)}>
                    here
                </button>.&nbsp;   Otherwise, click next.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMin5Plus)
        &&
            <React.Fragment>
                You must request data from the required number of electric vendors. Since
                there are at least five electricity vendors in your state who serve LIHEAP
                clients, this means you must request  <strong> and receive </strong> data
                from <strong> at least five </strong> electric vendors.
            </React.Fragment>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMin5Plus
          || model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMinUnder5)
        &&
            <React.Fragment>
                <p>
                    Since your data reliability issue arises from the fact that too few vendors complied
                    with your data request, let's explore some reasons why that might be the case.
                </p>
                <ol start={1}>
                    <li>Your agreements with electricity vendors do not include data collection requirements.</li>
                    <li>Your client waivers do not meet electric vendors&rsquo; privacy standards and therefore they feel it would be against their internal policies to share the billing information with you. </li>
                    <li>Your electric vendors are not alerted about data collection in a timely manner and are therefore unable to provide the necessary data before the reporting deadline.</li>
                    <li>A significant portion of your households are served by small municipal electric utilities or rural electric co-ops, but you do not request data from these smaller types of electric vendors because they are not one of the top 5 electric vendors.</li>
                </ol>
                <p>Let's walk through each of these issues so that you can assess whether any of them might be a problem for your data.</p>

            </React.Fragment>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMinUnder5)
        &&
            <React.Fragment>
                You must request data from enough electric vendors. Since there are 
                only  {model.totalNumVendors}  vendors in your state who serve LIHEAP clients, this means
                you must<strong>  request and receive </strong> data from <strong> all </strong> electric vendors. 
            </React.Fragment>
        }
    </div>
);

export default Assessment2aBottomParagraph;
